import { render, staticRenderFns } from "./PriorityBreakdown.vue?vue&type=template&id=a2b0797a&scoped=true&"
import script from "./PriorityBreakdown.vue?vue&type=script&lang=js&"
export * from "./PriorityBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PriorityBreakdown.vue?vue&type=style&index=0&id=a2b0797a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b0797a",
  null
  
)

export default component.exports